import { render, staticRenderFns } from "./MessageCode.vue?vue&type=template&id=f52b6578&scoped=true&"
import script from "./MessageCode.vue?vue&type=script&lang=js&"
export * from "./MessageCode.vue?vue&type=script&lang=js&"
import style0 from "./MessageCode.vue?vue&type=style&index=0&id=f52b6578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52b6578",
  null
  
)

export default component.exports